import React from 'react';
import PropTypes from 'prop-types';
import ExpenseTable from './ExpenseTable';

export default function NewprintExpenses({
  expenseSummary,
}) {
  if (!expenseSummary) return null;

  const [resource] = expenseSummary;
  if (!resource) return null;

  const savingsExpensesCollection = resource.attr('savingsExpenses');

  const housingExpensesCollection = resource.attr('housingExpenses');

  const transportationExpensesCollection = resource.attr('transportationExpenses');

  const lifestyleExpensesCollection = resource.attr('lifestyleExpenses');

  const debtExpensesCollection = resource.attr('debtExpenses');

  const savingsTotal = resource.attr('savingsMonthlyTotal');
  const housingTotal = resource.attr('housingMonthlyTotal');
  const transportationTotal = resource.attr('transportationMonthlyTotal');
  const lifestyleTotal = resource.attr('lifestyleMonthlyTotal');
  const debtTotal = resource.attr('debtMonthlyTotal');

  return (
    <>
      <ExpenseTable
        expensesCollection={savingsExpensesCollection}
        total={savingsTotal}
        title="Savings"
      />

      <ExpenseTable
        expensesCollection={housingExpensesCollection}
        total={housingTotal}
        title="Housing"
      />

      <ExpenseTable
        expensesCollection={transportationExpensesCollection}
        total={transportationTotal}
        title="Transportation"
      />

      <ExpenseTable
        expensesCollection={lifestyleExpensesCollection}
        total={lifestyleTotal}
        title="Lifestyle"
      />

      <ExpenseTable
        expensesCollection={debtExpensesCollection}
        total={debtTotal}
        title="Debt"
      />
    </>
  );
}

NewprintExpenses.propTypes = {
  expenseSummary: PropTypes.object.isRequired,
};
